<template>
  <div class="modal__cash">
    <div class="title">Возврат денежных средств</div>
    <div class="close" @click="func_close_modal">
      <i class="fa fa-window-close" aria-hidden="true"></i>
    </div>
    <div class="cash__wrapper" style="text-align: left; line-height: 1.6">
      <p>Для возврата денежных средств родителю необходимо:</p>
      <p>
        Написать заявление на возврат денежных средств. Заявление должно быть
        заполнено строго по установленному образцу.
      </p>
      <p>
        Готовое, правильно оформленное заявление необходимо направить в офис
        «Большой перемены» или отправить на электронную почту приёмной:
        <a href="mailto:bpkshp@mail.ru">bpkshp@mail.ru</a>
      </p>
      <p>
        Скачайте бланк заявления, внимательно заполните все необходимые поля,
        поставьте подпись и направьте его в установленном порядке.
      </p>

      <div style="margin: 20px 0">
        <label style="display: flex; align-items: center; cursor: pointer">
          <input
            type="checkbox"
            v-model="agreed"
            style="margin-right: 10px; width: auto"
          />
          <span
            >Я прочитал(а) и согласен(а) с условиями возврата денежных
            средств</span
          >
        </label>
      </div>

      <button
        class="btn-send"
        :disabled="!agreed"
        @click="downloadFile"
        style="
          background: #007bff;
          color: #fff;
          border: none;
          padding: 0.5rem 1rem;
          font-size: 1rem;
          cursor: pointer;
        "
        :style="{
          opacity: agreed ? 1 : 0.5,
          cursor: agreed ? 'pointer' : 'not-allowed',
        }"
      >
        Скачать бланк заявления
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      agreed: false,
    };
  },
  methods: {
    func_close_modal() {
      this.$store.commit('CHANGE_MODAL');
      this.$store.commit('CHANGE_MODAL_ID', 0);
    },
    downloadFile() {
      if (!this.agreed) return;
      const link = document.createElement('a');
      link.href = '/file/Заявление_на_возврат_денег_с_лиц_счета.pdf';
      link.download = 'Заявление_на_возврат_денег_с_лиц_счета.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped>
.title {
  margin-bottom: 10px;
}
.btn-send:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cash__wrapper p {
  margin-bottom: 10px;
}
</style>
